import type { VoicePermissionState } from "./voiceTrace";

export const WAKEWORD_REQUEST_KEY = "jarvis.chat.wakewordRequested";

export type WakewordGateReason =
  | "build_gate_disabled"
  | "voice_mode_off"
  | "microphone_not_granted"
  | "engine_unavailable"
  | "ready"
  | "off";

export interface WakewordGateInput {
  buildGateEnabled: boolean;
  requested: boolean;
  voiceMode: "off" | "server";
  permission: VoicePermissionState;
  engineAvailable: boolean;
}

export interface WakewordGateStatus {
  active: boolean;
  canRequest: boolean;
  label: "Wake aus" | "Wake Gate" | "Wake aktiv";
  reason: WakewordGateReason;
}

export function parseWakewordBuildGate(env: Record<string, unknown>): boolean {
  return env.VITE_SIMO_WAKEWORD_ENABLED === "1";
}

export function parseWakewordRequest(raw: string | null): boolean {
  return raw === "1";
}

export function serializeWakewordRequest(value: boolean): string {
  return value ? "1" : "0";
}

export function resolveWakewordGate(input: WakewordGateInput): WakewordGateStatus {
  if (!input.buildGateEnabled) {
    return {
      active: false,
      canRequest: false,
      label: "Wake Gate",
      reason: "build_gate_disabled",
    };
  }

  if (!input.requested) {
    return {
      active: false,
      canRequest: true,
      label: "Wake aus",
      reason: "off",
    };
  }

  if (input.voiceMode === "off") {
    return {
      active: false,
      canRequest: true,
      label: "Wake Gate",
      reason: "voice_mode_off",
    };
  }

  if (input.permission !== "granted") {
    return {
      active: false,
      canRequest: true,
      label: "Wake Gate",
      reason: "microphone_not_granted",
    };
  }

  if (!input.engineAvailable) {
    return {
      active: false,
      canRequest: true,
      label: "Wake Gate",
      reason: "engine_unavailable",
    };
  }

  return {
    active: true,
    canRequest: true,
    label: "Wake aktiv",
    reason: "ready",
  };
}
